import React from "react";
import LazyLoad from "react-lazyload";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProjectCard = React.memo(({ project }) => {
  const navigate = useNavigate();
  const formattedDate = new Date(project.date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Card
      sx={{
        backgroundColor: "#1A2E55",
        color: "#FFFFFF",
        borderRadius: "12px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 12px 36px rgba(0, 86, 179, 0.5)",
        },
      }}
    >
      <LazyLoad height={200} offset={100} once>
        <CardMedia
          component="img"
          height="200"
          image={project.image}
          alt={project.title}
          sx={{ borderRadius: "12px 12px 0 0", objectFit: "cover" }}
        />
      </LazyLoad>
      <CardContent sx={{ padding: "20px" }}>
        <Box sx={{ marginBottom: "8px" }}>
          {/* Display the human-readable formatted date */}
          <Typography
            variant="caption"
            sx={{
              color: "#B0BEC5",
              fontSize: "0.8rem",
              textTransform: "uppercase",
            }}
          >
            {formattedDate}
          </Typography>
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            marginBottom: "12px",
            color: "#A9C9EA",
            letterSpacing: "0.5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {project.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#D1D5DB",
            marginBottom: "16px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
            lineHeight: "1.5",
          }}
        >
          {project.description}
        </Typography>
        <Button
          onClick={() => navigate("/project/details/", { state: project })}
          variant="contained"
          sx={{
            backgroundImage: "linear-gradient(90deg, #10a7e0, #10a7e0)",
            color: "#FFFFFF",
            fontSize: "0.9rem",
            textTransform: "uppercase",
            borderRadius: "8px",
            padding: "8px 16px",
            boxShadow: "0 4px 14px rgba(0, 123, 255, 0.3)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundImage: "linear-gradient(90deg, #10a7e0, #10a7e0)",
              boxShadow: "0 6px 20px rgba(0, 86, 179, 0.4)",
              transform: "translateY(-2px)",
            },
          }}
        >
          View Details
        </Button>
      </CardContent>
    </Card>
  );
});

export default ProjectCard;
